import { render, staticRenderFns } from "./RegistrationOtpTimer.vue?vue&type=template&id=6d56abc1&scoped=true"
import script from "./RegistrationOtpTimer.vue?vue&type=script&lang=js"
export * from "./RegistrationOtpTimer.vue?vue&type=script&lang=js"
import style0 from "./RegistrationOtpTimer.vue?vue&type=style&index=0&id=6d56abc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56abc1",
  null
  
)

export default component.exports